// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Icon_wrapper__u_764","hover":"Icon_hover__z4K8A","hoverHighlight":"Icon_hoverHighlight__3JVSn","grow":"Icon_grow__QT0xU"};